var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Custom popover component to fix placement bug
 */
var InlinePop = function (props) {
    var 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    disablePortal = props.disablePortal, 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    anchorEl = props.anchorEl, open = props.open, popperChildren = props.children, rest = __rest(props, ["disablePortal", "anchorEl", "open", "children"]);
    var children = popperChildren;
    return open ? _jsx("div", __assign({}, rest, { children: children })) : null;
};
export default InlinePop;
